import * as React from "react";
import { forwardRef } from "react";
const SvgBlock = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 15.999, "data-name": "icon/null", viewBox: "0 0 16 15.999", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M11 3a8 8 0 1 1-8 8 8.01 8.01 0 0 1 8-8m0 1.231a6.765 6.765 0 0 0-5.154 11.151l9.442-9.633A6.74 6.74 0 0 0 11 4.231m5.154 2.384-9.442 9.632a6.772 6.772 0 0 0 9.442-9.633z", transform: "translate(-3 -3)", fill: "#fc636b" }));
const ForwardRef = forwardRef(SvgBlock);
export { ForwardRef as ReactComponent };
